import type { ComponentType } from "react";

type Page = ComponentType<{ mode: "dialogs" }>;
/** «Диалоги» once their code is here, as «Аналитика» (analytics-page-loader.ts): a lazy() page suspends on its first render
 * even with its code loaded, and React holds the content back for ~300 ms (17.10.2026: the list was asked 0.3 s after the
 * data had come). main.tsx loads the code with the page; App renders it directly then. */
let loaded: Page | null = null;
let loading: Promise<Page> | null = null;
export function loadDialogsPage(): Promise<Page> {
  loading ??= import("../pages/crm-deals-page").then((module) => (loaded = module.CrmDealsPage));
  return loading;
}
export const loadedDialogsPage = (): Page | null => loaded;
